<template>
    <div>
        <base-loading :visible="isLoading" />
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">
                <search-input v-model="search" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="col-span-full col-start-1">
                <bank-accounts-table 
                    :items="items" 
                    @loadMore="loadMore" 
                    @details="onDetails"
                    @sortChanged="onSortChanged" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useNotifier } from '@/composables/useNotifier'
import { useBankAccounts } from '../../composables/useBankAccounts'
import { useNavigator } from '@/composables/useNavigator'
import BankAccountsTable from './components/BankAccountsTable'
import BaseLoading from '@/views/app/components/BaseLoading'
import SearchInput from '@/views/app/components/SearchInput'

const { goTo } = useNavigator()
const { notify } = useNotifier()
const bankAccounts = useBankAccounts()
const items = computed(() => bankAccounts.state.items)
const currentPage = computed(() => bankAccounts.state.currentPage)
const lastPage = computed(() => bankAccounts.state.lastPage)
const isLoading = computed(() => bankAccounts.state.loading)
const search = ref('')
const sort = ref({})

const loadData = async (params = {}) => {
    const payload = {
        page: bankAccounts.state.currentPage || 1,
        search: search.value,
        column: sort.value.column,
        order: sort.value.order,
        ...params
    }
    const result = await bankAccounts.getBankAccounts(payload)
    if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
    if (currentPage.value >= lastPage.value) return
    const newPage = bankAccounts.state.currentPage + 1
    await loadData({ page: newPage })
}

const onSearch = async () => {
    await loadData({ page: 1, search: search.value })
}

const onDetails = (row) => {
  goTo({ name: 'hsbc-bank-account-reports', params: { account: row.id } })
}

const onSortChanged = async (sortData) => {
    sort.value.column = sortData.key
    sort.value.order = sortData.order
    await loadData({ column: sort.value.column, order: sort.value.order })
}

onMounted(() => loadData())

</script>
